<template>
  <router-view :key="route.fullPath" />
</template>

<script lang="ts">
import { defineComponent, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { setupApp } from '@/helpers/Utils'

export default defineComponent({
  name: 'TrackingApp',
  setup() {
    const route = useRoute()
    let timer: ReturnType<typeof setTimeout>

    const scheduleSetup = async () => {
      await setupApp()
      timer = setTimeout(scheduleSetup, 60000)
    }

    timer = setTimeout(scheduleSetup, 60000)

    onUnmounted(() => {
      clearTimeout(timer)
    })

    return {
      route,
    }
  },
})
</script>
